module.exports = __webpack_public_path__ + "img/icon_img6.a69c7646.png";